"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAccessToken = exports.mockUser = exports.mockAuthConfig = exports.mockAuth0AccessToken = exports.MockAuthClient = void 0;
var auth0_spa_js_1 = require("@auth0/auth0-spa-js");
var MockAuthClient = /** @class */ (function (_super) {
    __extends(MockAuthClient, _super);
    function MockAuthClient() {
        var _this = this;
        // this client just overried everything in auth0client
        try {
            _this = _super.call(this, null) || this;
        }
        catch (e) { }
        return _this;
    }
    MockAuthClient.prototype.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isAuthenticated;
            return __generator(this, function (_a) {
                isAuthenticated = !!window.sessionStorage.mockLogin && !!JSON.parse(window.sessionStorage.mockLogin);
                return [2 /*return*/, Promise.resolve(isAuthenticated)];
            });
        });
    };
    MockAuthClient.prototype.getUser = function () {
        return this.isAuthenticated().then(function (isAuthenticated) {
            return Promise.resolve(isAuthenticated ? exports.mockUser : null);
        });
    };
    MockAuthClient.prototype.getTokenSilently = function () {
        return this.isAuthenticated().then(function (isAuthenticated) {
            return Promise.resolve(isAuthenticated ? exports.mockAuth0AccessToken : null);
        });
    };
    MockAuthClient.prototype.getIdTokenClaims = function () {
        return this.isAuthenticated().then(function (isAuthenticated) {
            return Promise.resolve(isAuthenticated
                ? __assign(__assign({}, exports.mockUser), { __raw: 'sd' }) : null);
        });
    };
    MockAuthClient.prototype.handleRedirectCallback = function () {
        return Promise.resolve();
    };
    MockAuthClient.prototype.checkSession = function () {
        return Promise.resolve();
    };
    MockAuthClient.prototype.logout = function () {
        window.sessionStorage.removeItem('mockLogin');
    };
    MockAuthClient.prototype.loginWithRedirect = function (config) {
        this.hasLoginRedirectedToPage = config.redirect_uri;
        return Promise.resolve();
    };
    return MockAuthClient;
}(auth0_spa_js_1.Auth0Client));
exports.MockAuthClient = MockAuthClient;
exports.mockAuth0AccessToken = 'test';
exports.mockAuthConfig = {
    audience: 'httpds://',
    client_id: 'test',
    domain: 'test',
    leeway: 300,
    redirect_uri: 'htto://',
    scope: 'openid',
    androidClientId: 'and1',
    iosClientId: 'ios1',
};
exports.mockUser = {};
exports.mockAccessToken = {};
